import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  overflow: visible;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  font-size: ', ';\n  min-width: 312px;\n  transition: opacity 0.2s;\n'], ['\n  position: relative;\n  overflow: visible;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  font-size: ', ';\n  min-width: 312px;\n  transition: opacity 0.2s;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  overflow: auto;\n  height: 100%;\n'], ['\n  overflow: auto;\n  height: 100%;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  transition: opacity 0.3s ease;\n  z-index: 1;\n  padding: ', ' 0 ', ' 0;\n  ', ';\n'], ['\n  transition: opacity 0.3s ease;\n  z-index: 1;\n  padding: ', ' 0 ', ' 0;\n  ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n      opacity: 0.3;\n      pointer-events: none;\n    '], ['\n      opacity: 0.3;\n      pointer-events: none;\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n  padding: ', ' 32px;\n  margin-top: auto;\n  flex-shrink: 0;\n  button {\n    margin-left: auto;\n    width: 100%;\n  }\n'], ['\n  padding: ', ' 32px;\n  margin-top: auto;\n  flex-shrink: 0;\n  button {\n    margin-left: auto;\n    width: 100%;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  &&&& {\n    position: absolute;\n    right: 0;\n    top: 0;\n    padding: 20px 20px 10px 10px;\n    cursor: pointer;\n    z-index: 10;\n    width: 40px;\n    height: 40px;\n  }\n'], ['\n  &&&& {\n    position: absolute;\n    right: 0;\n    top: 0;\n    padding: 20px 20px 10px 10px;\n    cursor: pointer;\n    z-index: 10;\n    width: 40px;\n    height: 40px;\n  }\n']);

import styled, { css } from 'styled-components';
import { styles } from 'gipsy-misc';
import { Icon } from 'gipsy-ui';

export var panelStyle = css(_templateObject, styles.fonts.fontSizeSmall);

export var Scrollable = styled.div(_templateObject2);

export var Body = styled.div(_templateObject3, styles.spacings.large, styles.spacings.normal, function (props) {
  return props.activePrompt && css(_templateObject4);
});

export var FooterContainer = styled.div(_templateObject5, styles.spacings.medium);

export var CloseIcon = styled(Icon)(_templateObject6);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/Panel/index.js
// module id = 219
// module chunks = 0